import { render, staticRenderFns } from "./MyCalls.vue?vue&type=template&id=3679e7d7&scoped=true&"
import script from "./MyCalls.vue?vue&type=script&lang=js&"
export * from "./MyCalls.vue?vue&type=script&lang=js&"
import style0 from "./MyCalls.vue?vue&type=style&index=0&id=3679e7d7&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3679e7d7",
  null
  
)

export default component.exports